/**
 * @file [...params].tsx
 *
 * @fileoverview This is the job wizard page for choosing the job upgrades.
 */
import JobiqoJobWizardBundlesPage, {
  getServerSideProps,
} from '~/jobiqo/pages/job/wizard/bundles';
export default JobiqoJobWizardBundlesPage;
export { getServerSideProps };
